import React from "react";
import { useSelector } from "react-redux";
import { Box, Text, useThemeUI } from "theme-ui";

import { selectCustomisationStage } from "store/app";
import { useTranslation } from "hooks";
import * as styles from "./StageBar.styles";
import { CheckMarkInBoxIcon } from "components/icons";

export default function StageBar() {
  const { t } = useTranslation();

  const {
    theme: { isDesktop },
  } = useThemeUI();

  const customisationStatus = useSelector(selectCustomisationStage);

  const stageBarContent = [
    {
      label: { desktop: t("1. choose family"), mobile: t("step 1") },
      step: "step1",
    },
    {
      label: { desktop: t("2. customize"), mobile: t("step 2") },
      step: "step2",
    },
    {
      label: { desktop: t("3. review"), mobile: t("step 3") },
      step: "step3",
    },
    {
      label: { desktop: t("4. order gear"), mobile: t("step 4") },
      step: "step4",
    },
  ];

  return (
    <Box sx={styles.stageBarBackground}>
      {stageBarContent.map(({ label, step }) => {
        const { isInProgress, isComplete } = customisationStatus[step];
        return (
          <Box
            sx={styles.stageStatus({
              isComplete,
              isInProgress,
            })}
            key={step}
          >
            {!isComplete && (
              <Box
                sx={styles.checkBox({
                  isInProgress,
                })}
              />
            )}
            {isComplete && <CheckMarkInBoxIcon />}
            <Text
              as="div"
              variant={(!isComplete && !isInProgress && "copy2") || "copy2Bold"}
            >
              {isDesktop ? label.desktop : label.mobile}
            </Text>
          </Box>
        );
      })}
    </Box>
  );
}
